module.exports = __webpack_public_path__ + "assets/img/u6.2e5c5bfb.png";